/* =================================================================
   UNA HIJABI — Theme JS
   ================================================================= */
(function () {
  'use strict';

  /* ---------- Header fixed — suivi barre d'annonce ---------- */
  const header = document.querySelector('.header');
  if (header) {
    const ann = document.querySelector('.announcement');
    const syncHeader = () => {
      const annBottom = ann ? Math.max(0, ann.getBoundingClientRect().bottom) : 0;
      header.style.top = annBottom + 'px';
      if (annBottom === 0) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
    };
    window.addEventListener('scroll', syncHeader, { passive: true });
    window.addEventListener('resize', syncHeader);
    syncHeader();
  }

  /* ---------- Mobile menu ---------- */
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const mobileOverlay = document.querySelector('[data-mobile-overlay]');

  function openMenu() {
    if (mobileMenu) mobileMenu.classList.add('is-open');
    if (mobileOverlay) mobileOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeMenu() {
    if (mobileMenu) mobileMenu.classList.remove('is-open');
    if (mobileOverlay) mobileOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  if (menuToggle) menuToggle.addEventListener('click', openMenu);
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeMenu);
  document.querySelectorAll('[data-menu-close]').forEach(b => b.addEventListener('click', closeMenu));

  /* ---------- Cart drawer ---------- */
  const cartDrawer = document.getElementById('cart-drawer');
  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  document.querySelectorAll('[data-cart-open]').forEach(b => b.addEventListener('click', (e) => {
    e.preventDefault();
    openCart();
  }));
  document.querySelectorAll('[data-cart-close]').forEach(b => b.addEventListener('click', closeCart));

  /* ---------- Fetch cart contents ---------- */
  async function fetchCart() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      renderCart(cart);
      updateCartCount(cart.item_count);
    } catch (err) { console.error(err); }
  }

  function formatMoney(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    try {
      return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + currency;
    }
  }

  function renderCart(cart) {
    const body = document.querySelector('[data-cart-body]');
    if (!body) return;
    if (cart.item_count === 0) {
      body.innerHTML = '<p class="cart-drawer__empty">Ton panier est vide pour le moment.</p>';
      return;
    }
    let html = '';
    cart.items.forEach(item => {
      html += `
        <div class="cart-item" data-key="${item.key}">
          <div class="cart-item__img">
            <img src="${item.image || ''}" alt="${item.product_title}" loading="lazy">
          </div>
          <div>
            <div class="cart-item__title">${item.product_title}</div>
            <div class="cart-item__meta">${item.variant_title !== 'Default Title' ? item.variant_title : ''}</div>
            <div class="cart-item__meta">Qté : ${item.quantity} × ${formatMoney(item.price)}</div>
            <a class="cart-item__remove" href="#" data-remove="${item.key}">Retirer</a>
          </div>
          <div class="cart-item__price">${formatMoney(item.price * item.quantity)}</div>
        </div>`;
    });
    if (cart.items_subtotal_price > cart.total_price) {
      html += `<div class="cart-summary__row" style="margin-top:1.5rem;">
        <span>Sous-total</span>
        <span>${formatMoney(cart.items_subtotal_price)}</span>
      </div>`;
      if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0) {
        cart.cart_level_discount_applications.forEach(function(d) {
          html += `<div class="cart-summary__row cart-summary__discount">
            <span>🏷 ${d.title}</span>
            <span class="cart-summary__discount-amount">-${formatMoney(d.total_allocated_amount)}</span>
          </div>`;
        });
      }
    }
    html += `<div class="cart-summary__row cart-summary__total" style="margin-top:1.5rem;">
      <span>Total</span>
      <span>${formatMoney(cart.total_price)}</span>
    </div>`;
    body.innerHTML = html;

    body.querySelectorAll('[data-remove]').forEach(a => {
      a.addEventListener('click', async (e) => {
        e.preventDefault();
        const key = a.getAttribute('data-remove');
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        });
        fetchCart();
      });
    });
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  /* ---------- Pack selector + couleur inline + panier ---------- */
  (function initProductActions() {
    var wrapper = document.querySelector('[data-product-actions]');
    if (!wrapper) return;

    var packsEl       = wrapper.querySelector('[data-packs]');
    var addBtn        = wrapper.querySelector('[data-add-to-cart]');
    var checkoutBtn   = wrapper.querySelector('[data-checkout]');
    var colorInline   = wrapper.querySelector('[data-color-inline]');
    var inlineTitle   = wrapper.querySelector('[data-inline-title]');
    var inlineBody    = wrapper.querySelector('[data-inline-body]');
    var inlineError   = wrapper.querySelector('[data-inline-error]');
    var inlineConfirm = wrapper.querySelector('[data-inline-confirm]');
    var inlineCancel  = wrapper.querySelector('[data-inline-cancel]');

    var selectedColors    = {};
    var colorsByPack      = {};
    var currentCount      = 1;
    var currentVariant    = wrapper.getAttribute('data-default-variant') || '';
    var currentVariantsMap = {};
    var currentPackName   = '';
    var pendingCheckout   = false;
    var variantAvailability = {};
    try { variantAvailability = JSON.parse(wrapper.getAttribute('data-variant-availability') || '{}'); } catch(e) { variantAvailability = {}; }

    // Est-ce que choisir `color` pour le groupe `groupIndex` laisse au moins une combinaison en stock ?
    function isColorAvailable(color, groupIndex) {
      var palette = ['Noir', 'Blanc'];
      var combos = [[]];
      for (var g = 1; g <= currentCount; g++) {
        var fixed = (g === groupIndex) ? color : selectedColors[String(g)];
        var next = [];
        combos.forEach(function(acc) {
          if (fixed) {
            next.push(acc.concat(fixed));
          } else {
            palette.forEach(function(c) { next.push(acc.concat(c)); });
          }
        });
        combos = next;
      }
      return combos.some(function(comboArr) {
        var vid = currentVariantsMap[comboArr.join('/')];
        return vid && variantAvailability[vid] !== false;
      });
    }

    // Confirm/cancel buttons replaced by main CTA buttons
    if (inlineConfirm) inlineConfirm.style.display = 'none';
    if (inlineCancel)  inlineCancel.style.display  = 'none';

    function syncFromActivePack() {
      var active = packsEl && packsEl.querySelector('[data-pack].is-active');
      if (active) {
        currentVariant  = active.getAttribute('data-variant') || wrapper.getAttribute('data-default-variant') || '';
        currentCount    = parseInt(active.getAttribute('data-count') || '1', 10);
        currentPackName = active.getAttribute('data-name') || '';
        try { currentVariantsMap = JSON.parse(active.getAttribute('data-variants-map') || '{}'); } catch(e) { currentVariantsMap = {}; }
      }
    }

    function renderSwatches() {
      if (currentPackName) colorsByPack[currentPackName] = selectedColors;
      selectedColors = colorsByPack[currentPackName] ? Object.assign({}, colorsByPack[currentPackName]) : {};
      if (inlineTitle) inlineTitle.textContent = currentCount === 1
        ? 'Choisis la couleur de ton bonnet'
        : 'Choisis la couleur de chaque bonnet';
      if (inlineBody) {
        inlineBody.innerHTML = '';
        for (var i = 1; i <= currentCount; i++) {
          var lbl = currentCount === 1 ? 'Couleur' : 'Bonnet ' + i;
          var g = document.createElement('div');
          g.className = 'color-group-inline';
          g.innerHTML =
            '<p class="color-group-inline__label">' + lbl + '</p>' +
            '<div class="color-swatches-inline">' +
              '<button type="button" class="swatch-inline swatch-inline--noir" data-color="Noir" data-group="' + i + '">' +
                '<span class="swatch-inline__circle"></span><span class="swatch-inline__name">Noir</span>' +
                '<span class="swatch-inline__tooltip" role="status">Rupture de stock</span>' +
              '</button>' +
              '<button type="button" class="swatch-inline swatch-inline--blanc" data-color="Blanc" data-group="' + i + '">' +
                '<span class="swatch-inline__circle"></span><span class="swatch-inline__name">Blanc</span>' +
                '<span class="swatch-inline__tooltip" role="status">Rupture de stock</span>' +
              '</button>' +
            '</div>';
          inlineBody.appendChild(g);
        }
        inlineBody.querySelectorAll('.swatch-inline').forEach(function(sw) {
          var grp = sw.getAttribute('data-group');
          var col = sw.getAttribute('data-color');
          if (selectedColors[grp] === col) sw.classList.add('is-active');
          if (!isColorAvailable(col, parseInt(grp, 10))) {
            sw.classList.add('is-disabled');
            sw.setAttribute('aria-disabled', 'true');
            sw.addEventListener('click', function(e) {
              e.preventDefault();
              sw.classList.add('show-tooltip');
              clearTimeout(sw._tooltipTimer);
              sw._tooltipTimer = setTimeout(function() { sw.classList.remove('show-tooltip'); }, 2200);
            });
            return;
          }
          sw.addEventListener('click', function() {
            inlineBody.querySelectorAll('.swatch-inline[data-group="' + grp + '"]').forEach(function(s) {
              s.classList.remove('is-active');
            });
            sw.classList.add('is-active');
            selectedColors[grp] = col;
            colorsByPack[currentPackName] = Object.assign({}, selectedColors);
            if (inlineError) inlineError.style.display = 'none';
            if (grp === '1') {
              var thumbs = document.querySelectorAll('[data-thumb]');
              var idx = col === 'Blanc' ? 1 : 0;
              if (thumbs[idx]) thumbs[idx].click();
            }
            renderSwatches();
          });
        });
      }
      if (inlineError) inlineError.style.display = 'none';
      if (colorInline) colorInline.style.display = '';
      var activePack = packsEl && packsEl.querySelector('[data-pack].is-active');
      if (activePack && colorInline) {
        activePack.parentNode.insertBefore(colorInline, activePack.nextSibling);
      }
    }

    function validateColors() {
      if (Object.keys(selectedColors).length < currentCount) {
        if (inlineError) {
          inlineError.textContent = currentCount === 1
            ? 'Choisis une couleur pour ton bonnet avant de continuer.'
            : 'Choisis une couleur pour chaque bonnet avant de continuer.';
          inlineError.style.display = '';
        }
        return false;
      }
      return true;
    }

    async function sendToCart() {
      var colorKey = [];
      for (var k = 1; k <= currentCount; k++) colorKey.push(selectedColors[String(k)]);
      var resolvedId = currentVariantsMap[colorKey.join('/')] || currentVariant;
      if (!resolvedId) return;
      var props = { 'Pack': currentPackName };
      for (var i = 1; i <= currentCount; i++) {
        props[currentCount === 1 ? 'Couleur' : 'Bonnet ' + i] = selectedColors[String(i)];
      }
      var btn = pendingCheckout ? checkoutBtn : addBtn;
      var orig = btn ? btn.textContent : '';
      if (btn) { btn.textContent = '...'; btn.disabled = true; }
      try {
        var res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: resolvedId, quantity: 1, properties: props })
        });
        if (!res.ok) throw new Error();
        if (btn) { btn.textContent = orig; btn.disabled = false; }
        renderSwatches();
        if (pendingCheckout) { window.location.href = '/checkout'; } else { openCart(); }
      } catch (_) {
        alert('Un souci est survenu. Merci de reessayer.');
        if (btn) { btn.textContent = orig; btn.disabled = false; }
      }
    }

    if (packsEl) {
      var packs = packsEl.querySelectorAll('[data-pack]');
      packs.forEach(function(pack) {
        pack.addEventListener('click', function() {
          if (currentPackName) colorsByPack[currentPackName] = Object.assign({}, selectedColors);
          packs.forEach(function(p) { p.classList.remove('is-active'); });
          pack.classList.add('is-active');
          currentVariant  = pack.getAttribute('data-variant') || wrapper.getAttribute('data-default-variant') || '';
          currentCount    = parseInt(pack.getAttribute('data-count') || '1', 10);
          currentPackName = pack.getAttribute('data-name') || '';
          try { currentVariantsMap = JSON.parse(pack.getAttribute('data-variants-map') || '{}'); } catch(e) { currentVariantsMap = {}; }
          renderSwatches();
        });
      });
      syncFromActivePack();
    }

    renderSwatches();

    if (addBtn) addBtn.addEventListener('click', function() {
      if (!validateColors()) return;
      pendingCheckout = false;
      sendToCart();
    });
    if (checkoutBtn) checkoutBtn.addEventListener('click', function() {
      if (!validateColors()) return;
      pendingCheckout = true;
      sendToCart();
    });

    // Pre-select pack and colors from URL params (coming from homepage)
    var urlParams = new URLSearchParams(window.location.search);
    var packParam = urlParams.get('pack');
    if (packParam && packsEl) {
      var targetPack = null;
      packsEl.querySelectorAll('[data-pack]').forEach(function(p) {
        if (p.getAttribute('data-name') === packParam) targetPack = p;
      });
      if (targetPack) {
        targetPack.click();
        syncFromActivePack();
        for (var j = 1; j <= currentCount; j++) {
          var c = urlParams.get('bonnet' + j);
          if (c) {
            selectedColors[String(j)] = c;
            if (inlineBody) {
              inlineBody.querySelectorAll('.swatch-inline[data-group="' + j + '"]').forEach(function(s) {
                if (s.getAttribute('data-color') === c) s.classList.add('is-active');
                else s.classList.remove('is-active');
              });
            }
          }
        }
      }
    }
  })();

  /* ---------- Product gallery ---------- */
  document.querySelectorAll('[data-gallery]').forEach(gallery => {
    const thumbs = Array.from(gallery.querySelectorAll('[data-thumb]'));
    const main   = gallery.querySelector('[data-main-image]');
    const prevBtn = gallery.querySelector('[data-gallery-prev]');
    const nextBtn = gallery.querySelector('[data-gallery-next]');
    let current = 0;

    function goTo(index) {
      if (!thumbs.length) return;
      current = Math.max(0, Math.min(index, thumbs.length - 1));
      thumbs.forEach(t => t.classList.remove('is-active'));
      thumbs[current].classList.add('is-active');
      if (main) {
        const src = thumbs[current].getAttribute('data-src');
        const img = main.querySelector('img');
        if (img && src) img.src = src;
      }
      if (prevBtn) prevBtn.disabled = current === 0;
      if (nextBtn) nextBtn.disabled = current === thumbs.length - 1;
    }

    thumbs.forEach((thumb, i) => {
      thumb.addEventListener('click', () => goTo(i));
    });

    if (prevBtn) prevBtn.addEventListener('click', () => goTo(current - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => goTo(current + 1));

    /* Swipe tactile */
    var touchStartX = 0;
    if (main) {
      main.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].clientX;
      }, { passive: true });
      main.addEventListener('touchend', function(e) {
        var dx = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(dx) < 40) return;
        if (dx < 0) goTo(current + 1);
        else goTo(current - 1);
      }, { passive: true });
    }

    goTo(0);
  });

  /* ---------- Read more (product desc) ---------- */
  document.querySelectorAll('[data-read-more]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var wrap = btn.closest('.product-info__desc-wrap');
      var rest = wrap.querySelector('[data-desc-rest]');
      var isOpen = rest.style.display !== 'none';
      rest.style.display = isOpen ? 'none' : '';
      btn.textContent = isOpen ? 'Lire plus ↓' : 'Lire moins ↑';
    });
  });

  /* ---------- Size disclaimer toggle ---------- */
  document.querySelectorAll('[data-size-toggle]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var body = btn.closest('.size-disclaimer').querySelector('[data-size-body]');
      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      if (isOpen) { body.setAttribute('hidden', ''); } else { body.removeAttribute('hidden'); }
    });
  });

  /* ---------- FAQ / accordion ---------- */
  document.querySelectorAll('[data-accordion]').forEach(container => {
    const items = container.querySelectorAll('[data-accordion-item]');
    items.forEach(item => {
      const trigger = item.querySelector('[data-accordion-trigger]');
      if (!trigger) return;
      trigger.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-open');
        // Optional: accordion-close-others
        // items.forEach(i => i.classList.remove('is-open'));
        item.classList.toggle('is-open', !isOpen);
      });
    });
  });

  /* ---------- Ritual carousel ---------- */
  document.querySelectorAll('[data-ritual-slider]').forEach(function(slider) {
    var slides   = Array.from(slider.querySelectorAll('.ritual__slide'));
    var wrap     = slider.closest('.ritual__slider-wrap');
    var prevBtn  = wrap && wrap.querySelector('[data-ritual-prev]');
    var nextBtn  = wrap && wrap.querySelector('[data-ritual-next]');
    var capNum   = wrap && wrap.querySelector('[data-cap-num-out]');
    var capTitle = wrap && wrap.querySelector('[data-cap-title-out]');
    var capDesc  = wrap && wrap.querySelector('[data-cap-desc-out]');
    var currentIndex = 0;
    var GAP = 14;

    function updateSlides() {
      var sliderW = slider.offsetWidth;
      var mobile  = window.innerWidth <= 700;
      /* Active: 9:16 based on actual slider height */
      var W     = mobile
        ? Math.round(window.innerWidth * 0.72)
        : Math.round(slider.offsetHeight * 9 / 16);
      /* Side slides are 52% of active — clearly smaller height via aspect-ratio */
      var sideW = Math.round(W * (mobile ? 0.75 : 0.72));
      var activeLeft = mobile ? Math.round((sliderW - W) / 2) : 0;

      var sideLefts = [];
      var acc = activeLeft + W + GAP;
      for (var p = 0; p < slides.length; p++) {
        sideLefts.push(acc);
        acc += sideW + GAP;
      }

      slides.forEach(function(s, i) {
        var pos = i - currentIndex;
        s.classList.remove('is-active', 'is-side');

        if (pos === -1) {
          s.classList.add('is-side');
          s.style.width         = sideW + 'px';
          s.style.height        = '';
          s.style.left          = (activeLeft - GAP - sideW) + 'px';
          s.style.opacity       = '1';
          s.style.transform     = 'none';
          s.style.filter        = 'brightness(0.45)';
          s.style.pointerEvents = 'auto';
          s.style.zIndex        = '3';
          s.style.cursor        = 'pointer';
        } else if (pos < -1) {
          s.style.width         = sideW + 'px';
          s.style.height        = '';
          s.style.left          = (activeLeft - GAP - sideW * 2.5) + 'px';
          s.style.opacity       = '0';
          s.style.transform     = 'none';
          s.style.filter        = '';
          s.style.pointerEvents = 'none';
          s.style.zIndex        = '0';
          s.style.cursor        = '';
        } else if (pos === 0) {
          s.classList.add('is-active');
          s.style.width         = W + 'px';
          s.style.height        = mobile ? '' : '100%';
          s.style.left          = activeLeft + 'px';
          s.style.opacity       = '1';
          s.style.transform     = 'none';
          s.style.filter        = 'brightness(1)';
          s.style.pointerEvents = 'auto';
          s.style.zIndex        = '4';
          s.style.cursor        = 'default';
        } else {
          s.classList.add('is-side');
          s.style.width         = sideW + 'px';
          s.style.height        = '';
          s.style.left          = sideLefts[pos - 1] + 'px';
          s.style.opacity       = '1';
          s.style.transform     = 'none';
          s.style.filter        = 'brightness(0.45)';
          s.style.pointerEvents = 'auto';
          s.style.zIndex        = String(3 - pos);
          s.style.cursor        = 'pointer';
        }
      });

      var active = slides[currentIndex];
      if (!active) return;
      if (capNum)   capNum.textContent   = active.getAttribute('data-cap-num')   || '';
      if (capTitle) capTitle.textContent = active.getAttribute('data-cap-title') || '';
      if (capDesc)  capDesc.textContent  = active.getAttribute('data-cap-desc')  || '';
    }

    function updateVideos() {
      slides.forEach(function(s) {
        var v = s.querySelector('video');
        if (!v) return;
        if (s === slides[currentIndex]) {
          v.muted = true;
          v.currentTime = 0;
          var p = v.play();
          if (p !== undefined) {
            p.catch(function() {
              var clone = v.cloneNode(true);
              clone.muted = true;
              clone.setAttribute('muted', '');
              clone.setAttribute('autoplay', '');
              clone.setAttribute('loop', '');
              clone.setAttribute('playsinline', '');
              clone.setAttribute('preload', 'auto');
              v.parentNode.replaceChild(clone, v);
            });
          }
        } else {
          v.pause();
          v.currentTime = 0;
        }
      });
    }

    function goTo(index) {
      currentIndex = index;
      updateSlides();
      updateVideos();
    }

    slides.forEach(function(slide) {
      slide.addEventListener('click', function() {
        if (!slide.classList.contains('is-side')) return;
        goTo(slides.indexOf(slide));
      });
    });

    if (prevBtn) prevBtn.addEventListener('click', function() {
      if (currentIndex > 0) goTo(currentIndex - 1);
    });
    if (nextBtn) nextBtn.addEventListener('click', function() {
      if (currentIndex < slides.length - 1) goTo(currentIndex + 1);
    });

    /* Swipe tactile mobile */
    var touchStartX = 0;
    slider.addEventListener('touchstart', function(e) {
      touchStartX = e.changedTouches[0].clientX;
    }, { passive: true });
    slider.addEventListener('touchend', function(e) {
      var dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) < 40) return;
      if (dx < 0 && currentIndex < slides.length - 1) goTo(currentIndex + 1);
      else if (dx > 0 && currentIndex > 0) goTo(currentIndex - 1);
    }, { passive: true });

    updateSlides();
    window.addEventListener('resize', updateSlides);

    /* Préchargement agressif de toutes les vidéos */
    slides.forEach(function(s, i) {
      var v = s.querySelector('video');
      if (!v) return;
      v.setAttribute('preload', 'auto');
      v.muted = true;
      v.load();
      if (i !== 0) {
        v.play().then(function() {
          v.pause();
          v.currentTime = 0;
        }).catch(function() {});
      }
    });

    /* Initialisation vidéos */
    updateVideos();
  });

  /* ---------- Pack tabs (mobile selector) ---------- */
  document.querySelectorAll('[data-pack-tab]').forEach(function(tab) {
    tab.addEventListener('click', function() {
      var idx = tab.getAttribute('data-pack-tab');
      document.querySelectorAll('[data-pack-tab]').forEach(function(t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
      });
      document.querySelectorAll('[data-pack-panel]').forEach(function(p) {
        p.classList.remove('is-active');
      });
      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');
      var panel = document.querySelector('[data-pack-panel="' + idx + '"]');
      if (panel) panel.classList.add('is-active');
    });
  });

  /* ---------- Pack quick-add (homepage) ---------- */
  (function initPackCards() {
    document.querySelectorAll('[data-pack-card]').forEach(function(card) {
      var variantId   = card.getAttribute('data-variant');
      var variantsMap = {};
      try { variantsMap = JSON.parse(card.getAttribute('data-variants-map') || '{}'); } catch(e) {}
      var count       = parseInt(card.getAttribute('data-count') || '1', 10);
      var packName    = card.getAttribute('data-name') || '';
      var addBtn      = card.querySelector('[data-pack-add]');
      var ctaWrap     = card.querySelector('[data-pack-cta]');
      var pickerWrap  = card.querySelector('[data-pack-color-picker]');
      var colorTitle  = card.querySelector('[data-pack-color-title]');
      var colorGroups = card.querySelector('[data-pack-color-groups]');
      var colorError  = card.querySelector('[data-pack-color-error]');
      var confirmBtn  = card.querySelector('[data-pack-confirm]');
      var cancelBtn   = card.querySelector('[data-pack-cancel]');
      var selectedColors = {};

      function showPicker() {
        // Fermer tous les autres pickers ouverts
        document.querySelectorAll('[data-pack-card]').forEach(function(otherCard) {
          if (otherCard === card) return;
          var op = otherCard.querySelector('[data-pack-color-picker]');
          var oc = otherCard.querySelector('[data-pack-cta]');
          if (op && op.style.display === 'block') {
            op.style.display = 'none';
            if (oc) oc.style.display = 'block';
          }
        });
        if (colorTitle) colorTitle.textContent = count === 1
          ? 'Choisis la couleur de ton bonnet'
          : 'Choisis la couleur de chaque bonnet';
        if (colorGroups) {
          colorGroups.innerHTML = '';
          for (var i = 1; i <= count; i++) {
            var lbl = count === 1 ? 'Couleur' : 'Bonnet ' + i;
            var g = document.createElement('div');
            g.className = 'pack__color-group-item';
            g.innerHTML =
              '<p class="pack__color-group-label">' + lbl + '</p>' +
              '<div class="pack__color-swatches">' +
                '<button type="button" class="pack__swatch pack__swatch--noir" data-color="Noir" data-group="' + i + '">' +
                  '<span class="pack__swatch-circle"></span><span>Noir</span>' +
                '</button>' +
                '<button type="button" class="pack__swatch pack__swatch--blanc" data-color="Blanc" data-group="' + i + '">' +
                  '<span class="pack__swatch-circle"></span><span>Blanc</span>' +
                '</button>' +
              '</div>';
            colorGroups.appendChild(g);
          }
          colorGroups.querySelectorAll('.pack__swatch').forEach(function(sw) {
            var grp = sw.getAttribute('data-group');
            var col = sw.getAttribute('data-color');
            if (selectedColors[grp] === col) sw.classList.add('is-active');
            sw.addEventListener('click', function() {
              colorGroups.querySelectorAll('.pack__swatch[data-group="' + grp + '"]').forEach(function(s) {
                s.classList.remove('is-active');
              });
              sw.classList.add('is-active');
              selectedColors[grp] = col;
              if (colorError) colorError.style.display = 'none';
            });
          });
        }
        if (colorError) colorError.style.display = 'none';
        if (ctaWrap) ctaWrap.style.display = 'none';
        if (pickerWrap) pickerWrap.style.display = 'block';
        card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }

      function hidePicker() {
        if (ctaWrap) ctaWrap.style.display = 'block';
        if (pickerWrap) pickerWrap.style.display = 'none';
      }

      if (addBtn) addBtn.addEventListener('click', showPicker);
      if (cancelBtn) cancelBtn.addEventListener('click', hidePicker);

      var imgLink = card.querySelector('[data-pack-img-link]');
      if (imgLink) {
        imgLink.addEventListener('click', function(e) {
          var base = (imgLink.getAttribute('href') || '').split('?')[0];
          if (!base) return;
          e.preventDefault();
          var params = new URLSearchParams({ pack: packName });
          for (var j = 1; j <= count; j++) {
            if (selectedColors[String(j)]) params.set('bonnet' + j, selectedColors[String(j)]);
          }
          window.location.href = base + '?' + params.toString();
        });
      }

      if (confirmBtn) {
        confirmBtn.addEventListener('click', async function() {
          if (Object.keys(selectedColors).length < count) {
            if (colorError) {
              colorError.textContent = count === 1
                ? 'Choisis une couleur avant de continuer.'
                : 'Choisis une couleur pour chaque bonnet.';
              colorError.style.display = 'block';
            }
            return;
          }
          var colorKey = [];
          for (var k = 1; k <= count; k++) colorKey.push(selectedColors[String(k)]);
          var resolvedId = variantsMap[colorKey.join('/')] || variantId;
          if (!resolvedId) return;
          var props = { 'Pack': packName };
          for (var i = 1; i <= count; i++) {
            props[count === 1 ? 'Couleur' : 'Bonnet ' + i] = selectedColors[String(i)];
          }
          var orig = confirmBtn.textContent;
          confirmBtn.textContent = '...';
          confirmBtn.disabled = true;
          try {
            var res = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: resolvedId, quantity: 1, properties: props })
            });
            if (!res.ok) throw new Error();
            confirmBtn.textContent = orig;
            confirmBtn.disabled = false;
            selectedColors = {};
            hidePicker();
            openCart();
          } catch (_) {
            alert('Un souci est survenu. Merci de reessayer.');
            confirmBtn.textContent = orig;
            confirmBtn.disabled = false;
          }
        });
      }
    });
  })();

  /* ---------- Initial cart count load ---------- */
  fetchCart();

  /* ---------- Before / After compare slider ---------- */
  document.querySelectorAll('[data-compare-slider]').forEach(function(slider) {
    var afterWrap = slider.querySelector('[data-compare-after]');
    var handle    = slider.querySelector('[data-compare-handle]');
    if (!afterWrap || !handle) return;

    var dragging = false;

    function setPos(clientX) {
      var rect = slider.getBoundingClientRect();
      var pct  = Math.max(2, Math.min(98, ((clientX - rect.left) / rect.width) * 100));
      afterWrap.style.width = pct + '%';
      handle.style.left     = pct + '%';
      var fullW = rect.width + 'px';
      afterWrap.querySelectorAll('img, div').forEach(function(el) { el.style.minWidth = fullW; });
    }

    slider.addEventListener('mousedown',  function(e) { dragging = true; slider.classList.add('is-dragging'); setPos(e.clientX); });
    slider.addEventListener('touchstart', function(e) { dragging = true; slider.classList.add('is-dragging'); setPos(e.touches[0].clientX); }, { passive: true });
    window.addEventListener('mousemove',  function(e) { if (dragging) setPos(e.clientX); });
    window.addEventListener('touchmove',  function(e) { if (dragging) setPos(e.touches[0].clientX); }, { passive: true });
    window.addEventListener('mouseup',    function()  { dragging = false; slider.classList.remove('is-dragging'); });
    window.addEventListener('touchend',   function()  { dragging = false; slider.classList.remove('is-dragging'); });
  });

  /* ---------- Product detail tabs ---------- */
  document.querySelectorAll('[data-pdt-nav]').forEach(function(nav) {
    var btns = nav.querySelectorAll('[data-pdt-btn]');
    btns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var target = btn.getAttribute('data-pdt-btn');
        btns.forEach(function(b) { b.classList.remove('is-active'); });
        document.querySelectorAll('[data-pdt-panel]').forEach(function(p) { p.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var panel = document.querySelector('[data-pdt-panel="' + target + '"]');
        if (panel) {
          panel.classList.add('is-active');
          if (panel.querySelector('[data-ritual-slider]')) {
            window.dispatchEvent(new Event('resize'));
          }
        }
      });
    });
  });

  /* ---------- Reviews slider (un avis à la fois) ---------- */
  document.querySelectorAll('[data-reviews-slider]').forEach(function(root) {
    var slides = Array.from(root.querySelectorAll('[data-review-slide]'));
    var dots = Array.from(root.querySelectorAll('[data-review-dot]'));
    if (slides.length <= 1) return;

    var index = 0;
    var timer = null;
    var DELAY = 5000;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function show(next) {
      slides[index].classList.remove('is-active');
      if (dots[index]) {
        dots[index].classList.remove('is-active');
        dots[index].setAttribute('aria-current', 'false');
      }
      index = (next + slides.length) % slides.length;
      slides[index].classList.add('is-active');
      if (dots[index]) {
        dots[index].classList.add('is-active');
        dots[index].setAttribute('aria-current', 'true');
      }
    }

    function play() {
      if (reducedMotion) return;
      stop();
      timer = setInterval(function () { show(index + 1); }, DELAY);
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { show(i); play(); });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', play);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', play);

    play();
  });

  /* ---------- Scroll jusqu'au message de confirmation de formulaire ---------- */
  (function() {
    var notice = document.getElementById('ContactFormNotice');
    if (!notice) return;
    notice.scrollIntoView({ behavior: 'smooth', block: 'center' });
    notice.focus({ preventScroll: true });
  })();

  /* ---------- Suivi de commande : détection transporteur depuis le n° de suivi ---------- */
  (function() {
    var input = document.getElementById('tracking');
    if (!input) return;
    var form = input.closest('form');
    if (!form) return;

    function detectCarrier(raw) {
      var clean = (raw || '').trim().toUpperCase().replace(/\s+/g, '');
      if (/^[A-Z]{2}\d{9}[A-Z]{2}$/.test(clean)) return { carrier: 'chronopost', clean: clean };
      if (/^\d{6,10}$/.test(clean)) return { carrier: 'mondial-relay', clean: clean };
      return null;
    }

    function trackingUrl(result) {
      if (result.carrier === 'chronopost') {
        return 'https://www.chronopost.fr/tracking-no-cms/suivi-colis?listeNumerosLT=' + encodeURIComponent(result.clean) + '&langue=fr';
      }
      if (result.carrier === 'mondial-relay') {
        return 'https://www.mondialrelay.fr/suivi-de-colis?numeroExpedition=' + encodeURIComponent(result.clean);
      }
      return null;
    }

    var errorEl = document.createElement('p');
    errorEl.style.cssText = 'color:#B05555;font-size:14px;margin-top:10px;display:none;';
    errorEl.textContent = "Ce numéro ne correspond pas à un format Chronopost ou Mondial Relay reconnu. Vérifie qu'il est bien recopié, ou écris-nous à unahijabi.sav@gmail.com.";
    form.appendChild(errorEl);

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var result = detectCarrier(input.value);
      if (!result) {
        errorEl.style.display = '';
        return;
      }
      errorEl.style.display = 'none';
      window.open(trackingUrl(result), '_blank', 'noopener');
    });
  })();

  /* ---------- Article : sommaire cliquable + encadrés "à retenir" ---------- */
  document.querySelectorAll('.article__content').forEach(function (content) {
    // Encadrés "💡 À retenir"
    content.querySelectorAll('p').forEach(function (p) {
      var txt = p.textContent.trim();
      if (txt.indexOf('💡') === 0 || txt.toLowerCase().indexOf('à retenir') === 0) {
        p.classList.add('article-callout');
        p.innerHTML = p.innerHTML.replace(/(💡\s*)?(à retenir)/i, '<span class="article-callout__label">$1$2</span>');
      }
    });

    // Sommaire auto-généré et cliquable, à partir des vrais titres H2
    var headings = Array.from(content.querySelectorAll('h2')).filter(function (h) {
      return h.textContent.trim() !== '';
    });
    if (headings.length < 2) return;

    var usedIds = {};
    headings.forEach(function (h, i) {
      var slug = h.textContent.trim().toLowerCase()
        .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '') || ('section-' + i);
      var id = slug, n = 1;
      while (usedIds[id]) { id = slug + '-' + (++n); }
      usedIds[id] = true;
      h.id = id;
    });

    var toc = document.createElement('div');
    toc.className = 'article-toc';
    var title = document.createElement('p');
    title.className = 'article-toc__title';
    title.textContent = 'Au sommaire';
    var list = document.createElement('ul');
    list.className = 'article-toc__list';
    headings.forEach(function (h) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent.trim();
      li.appendChild(a);
      list.appendChild(li);
    });
    toc.appendChild(title);
    toc.appendChild(list);

    // Remplace l'ancien sommaire texte brut (paragraphe "Au sommaire" + sa liste de flèches "→")
    var children = Array.from(content.children);
    var idx = children.findIndex(function (el) { return el.textContent.indexOf('Au sommaire') !== -1; });
    if (idx !== -1) {
      var oldTitle = children[idx];
      var oldList = children[idx + 1];
      oldTitle.replaceWith(toc);
      if (oldList && oldList.textContent.indexOf('→') !== -1) oldList.remove();
    } else {
      content.insertBefore(toc, content.firstElementChild);
    }
  });

  /* ---------- Scroll-reveal (léger) ---------- */
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fade-up');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('[data-reveal]').forEach(el => observer.observe(el));
  }

})();
